module.exports = __webpack_public_path__ + "img/lo.9c18bae7.jpg";